import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { ICourse } from 'interfaces/learningPath'
import { useRolesAndPermissions } from '../../../../../context/RolesAndPermissionsContext'
import { Wrapper } from './styled'

interface IProps {
  course: ICourse
  disabled?: boolean
}

export const Options = ({ course, disabled = false }: IProps) => {
  const { t } = useTranslation()
  const { removeCourse } = useRolesAndPermissions()
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToCourses.courses.table.actions'

  return (
    <Wrapper>
      <Tooltip
        getPopupContainer={() =>
          document.getElementById('lmsPage') as HTMLElement
        }
        title={t(`${prefix}.delete`)}
      >
        <Button
          onClick={() => removeCourse(course.id)}
          type="link"
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </Tooltip>
    </Wrapper>
  )
}

export default Options
